import { useMutation, UseMutationResult, useQueryClient } from 'react-query';

import { getTokenWithType } from './useAuth';

import { copyAccount } from 'utils/urls';

import { CopyAccount, CopyAccountOutput } from 'types/accounts';
import { ErrorModal } from 'types/modalTypes';

export async function postCopyAccount(params: CopyAccount): Promise<TResult> {
  const response = await fetch(copyAccount(params.AccountId), {
    method: 'POST',
    headers: {
      Authorization: getTokenWithType(),
      'content-type': 'application/json',
    },
    body: JSON.stringify(params),
  });
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: CopyAccountOutput;
  IsSuccess: boolean;
  StatusCode: number;
} & ErrorModal;

type TVariables = CopyAccount;

type TSnapshot = unknown;

function useSaveCopyAccount(): UseMutationResult<
  TResult,
  TError,
  TVariables,
  TSnapshot
> {
  const queryClient = useQueryClient();
  return useMutation(async (params: CopyAccount) => {
    const newAccount = await postCopyAccount(params);
    if (newAccount.Errors) throw newAccount;
    if (newAccount.StatusCode === 200) {
      queryClient.invalidateQueries(['accounts_list']);
    }
    return newAccount;
  });
}

export { useSaveCopyAccount };
